var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBilling = function SvgBilling(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8838 16H2.11616C1.22727 16 0.5 15.2461 0.5 14.3246V1.67539C0.5 0.753927 1.22727 0 2.11616 0H14.8838C15.7727 0 16.5 0.753927 16.5 1.67539V14.3246C16.5 15.2461 15.7727 16 14.8838 16ZM2.11616 0.837696C1.71212 0.837696 1.30808 1.25654 1.30808 1.67539V14.3246C1.30808 14.8272 1.71212 15.1623 2.11616 15.1623H14.8838C15.3687 15.1623 15.6919 14.7435 15.6919 14.3246V1.67539C15.6919 1.17277 15.2879 0.837696 14.8838 0.837696H2.11616Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0951 2.34546H0.903137V3.18316H16.0951V2.34546Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1071 14.0735H3.8142C3.57177 14.0735 3.41016 13.906 3.41016 13.6547C3.41016 13.4034 3.57177 13.2358 3.8142 13.2358H13.1071C13.3496 13.2358 13.5112 13.4034 13.5112 13.6547C13.5112 13.906 13.3496 14.0735 13.1071 14.0735Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0572 12.1467C11.8148 12.1467 11.6531 11.9792 11.6531 11.7279V4.85879C11.6531 4.60748 11.8148 4.43994 12.0572 4.43994C12.2996 4.43994 12.4612 4.60748 12.4612 4.85879V11.7279C12.4612 11.9792 12.2996 12.1467 12.0572 12.1467Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.50249 12.1466C8.26007 12.1466 8.09845 11.9791 8.09845 11.7278V6.53408C8.09845 6.28277 8.26007 6.11523 8.50249 6.11523C8.74492 6.11523 8.90653 6.28277 8.90653 6.53408V11.7278C8.90653 11.9791 8.74492 12.1466 8.50249 12.1466Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.9478 12.1468C4.70538 12.1468 4.54376 11.9793 4.54376 11.7279V8.20962C4.54376 7.95831 4.70538 7.79077 4.9478 7.79077C5.19023 7.79077 5.35184 7.95831 5.35184 8.20962V11.7279C5.35184 11.9793 5.10942 12.1468 4.9478 12.1468Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBilling, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/billing.c2297d3f.svg";
export { ForwardRef as ReactComponent };